import Vue from 'vue'
import App from './App.vue'
import router from './router'
import titleMixin from './mixins/titleMixin'
import Vuelidate from 'vuelidate'
import vueAwesomeCountdown from 'vue-awesome-countdown' 
import vSelect from 'vue-select'
import VueGtag from "vue-gtag";
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { ToastPlugin } from 'bootstrap-vue'
import { ModalPlugin } from 'bootstrap-vue'

var VueScrollTo = require('vue-scrollto');

Vue.mixin(titleMixin);
Vue.use(Vuelidate);
Vue.use(ToastPlugin);
Vue.use(vueAwesomeCountdown, 'vac'); 
Vue.use(VueScrollTo)
Vue.use(ModalPlugin)

Vue.component('v-select', vSelect)

Vue.use(VueGtag, {
  config: { id: "G-2C4ECEM83H" }
});

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')